import * as taskName from './task-name'
import { selectCustomer } from '../../../../customer/state/detail/selector'
import { createValidationMessage } from '../../../../validation/create-validation-message'
import { createUIDefinition } from '../default-task-definition'
import * as processUI from '../../process-ui'


export default createUIDefinition({
    taskName: taskName.ASSIGN_PHYSICIAN,
    overwriteWidget: true,
    widgetList: [
        {
            component: processUI.OVERVIEW,
        },
        {
            component: processUI.SALES_ORDER_OVERVIEW_WIDGET,
        },
        {
            component: processUI.INITIAL_HESITATION_WIDGET_CONTAINER,
        },
        {
            component: processUI.COMMENT_LIST,
        },
        {
            component: processUI.PHYSICIAN_AND_SUPPLIER_WIDGET,
        },
        {
            component: processUI.ANAMNESIS_LIST_WIDGET_CONTAINER,
        },
        {
            component: processUI.CUSTOMER_IMAGE_WIDGET,
        },
        {
            component: processUI.SCAN_FILE_UPLOAD_WIDGET,
        },
        {
            component: processUI.STATE_TRANSITION_LOG_CONTAINER,
        },
    ],
    taskValidatorSelector: [
        selectCustomer,
    ],
    taskValidator: (task, processInstance, taskName, eventName, customer) => {
        if (eventName !== 'physician_assigned') {
            return null
        }

        const messageList = []

        // make sure at least one is true
        if (!customer.partnerPhysicianId && !customer.treatingPhysicianId) {
            messageList.push(createValidationMessage('Please select a physician.', 'validateAssignPhysician.physicianId'))
        }

        // make sure at least one is true
        if (!customer.partnerSupplierId) {
            messageList.push(createValidationMessage('Please select a supplier', 'validateAssignPhysician.supplier'))
        }

        return messageList
    },
})



// WEBPACK FOOTER //
// ./src/modules/process/ui-definition/sales-order/set-and-shop-scan/assign-physician.js